import React from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";

import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";

import Checkbox from "@material-ui/core/Checkbox";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

@observer
class LegacyUserTableHeader extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };
    render() {
        const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;

        return (
            <TableHead>
                <TableRow>

                    <TableCell className="th-songlist" key="email" padding="default" sortDirection={orderBy === "email" ? order : false}>
                        <Tooltip title="Sort" placement="bottom-start" enterDelay={300}>
                            <TableSortLabel active={orderBy === "email"} direction={order} onClick={this.createSortHandler("email")}>
                                <Typography variant="subheading" className="head-title">
                                    Email
                                </Typography>
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>

                    <TableCell className="th-songlist" key="firstName" padding="default" sortDirection={orderBy === "firstName" ? order : false}>
                        <Tooltip title="Sort" placement="bottom-start" enterDelay={300}>
                            <TableSortLabel active={orderBy === "firstName"} direction={order} onClick={this.createSortHandler("firstName")}>
                                <Typography variant="subheading" className="head-title">
                                    FirstName
                                </Typography>
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>

                    <TableCell className="th-songlist" key="lastName" padding="default" sortDirection={orderBy === "lastName" ? order : false}>
                        <Tooltip title="Sort" placement="bottom-start" enterDelay={300}>
                            <TableSortLabel active={orderBy === "lastName"} direction={order} onClick={this.createSortHandler("lastName")}>
                                <Typography variant="subheading" className="head-title">
                                    LastName
                                </Typography>
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>

                    <TableCell className="th-songlist" key="status" padding="default" sortDirection={orderBy === "status" ? order : false}>
                        <Tooltip title="Sort" placement="bottom-start" enterDelay={300}>
                            <TableSortLabel active={orderBy === "status"} direction={order} onClick={this.createSortHandler("status")}>
                                <Typography variant="subheading" className="head-title">
                                    Status
                                </Typography>
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>

                    <TableCell className="th-songlist" key="musician" padding="default" sortDirection={orderBy === "musician" ? order : false}>
                        <Tooltip title="Sort" placement="bottom-start" enterDelay={300}>
                            <TableSortLabel active={orderBy === "musician"} direction={order} onClick={this.createSortHandler("musician")}>
                                <Typography variant="subheading" className="head-title">
                                    Musician
                                </Typography>
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>

                    <TableCell className="th-songlist" key="agent" padding="default" sortDirection={orderBy === "agent" ? order : false}>
                        <Tooltip title="Sort" placement="bottom-start" enterDelay={300}>
                            <TableSortLabel active={orderBy === "agent"} direction={order} onClick={this.createSortHandler("agent")}>
                                <Typography variant="subheading" className="head-title">
                                    Agent
                                </Typography>
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>

                    <TableCell className="th-songlist" key="venue" padding="default" sortDirection={orderBy === "venue" ? order : false}>
                        <Tooltip title="Sort" placement="bottom-start" enterDelay={300}>
                            <TableSortLabel active={orderBy === "venue"} direction={order} onClick={this.createSortHandler("venue")}>
                                <Typography variant="subheading" className="head-title">
                                    Venue
                                </Typography>
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>
                </TableRow>
            </TableHead>
        );
    }
}

LegacyUserTableHeader.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    rowCount: PropTypes.number.isRequired
};

export default LegacyUserTableHeader;
